// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { JoHeader } from './jo-header';
import { ManifestGroup } from './manifest-group';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Manifest extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** String(100) */
  manifestName!: string;
  /** DateTime */
  nextProcessDate?: Date;
  /** Guid */
  proximityManifestId!: string;
  /** String(200) */
  rRule?: string;
  /** Boolean */
  shouldIncludeInvoices!: boolean;
  /** Inv FK manifestId */
  joHeaders!: JoHeader[];
  /** Inv FK manifestId */
  manifestGroups!: ManifestGroup[];
}

